import dynamic from 'next/dynamic'
import Seo from '../../components/common/Seo'
import Header3 from '../../components/header/header-rslhome'

import Hero3 from '../../components/hero/hero-rslhome'
import Footer3 from '../../components/footer/footer-3'

import Brand2rsl from '../../components/brand/Brand2rsl'
import NewsBlogs from '../../components/newsBlogs/news-blogs'
import AppBanner from '../../components/home/home-2/AppBanner'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'

import { useRouter } from 'next/router'
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt'

import MainFilterSearchBox from '../../components/hero/hero-rslhome/MainFilterSearchBoxMobile'

// reduxß

// import { getCarList } from "../../redux/slices/product";
import { useEffect, useState } from 'react'
import Head from 'next/head'

import BannerSlider from '../../components/BannerImageViewSliderNew/BannerOne'
import VideoBanner from '../../components/BannerImageViewSliderNew/VideoBanner'
import CategorySlider from '../../components/BannerImageViewSliderNew/CategorySlider'
import PopularDestinations from '../../components/BannerImageViewSliderNew/PopularSlider'
import ActivitiesRSL from '../../components/activitiesrsl/ActivitiesRSL'
import FlightsRSL from '../../components/flight/FlightsRSL'
import HotelsRSL from '../../components/hotelrsl/HotelsRSL'
import Staycations from '../../components/staycations/Tour'
import CarRSL from '../../components/car-rsl/CarRSL'
import BusRSL from '../../components/bus-rsl/BusRSL'
import Holidays from '../../components/holidays/holidays'

const RslHome = () => {
  const router = useRouter()
  const pageName = router.asPath?.replaceAll('/', '') || ''

  const [currentTab, setCurrentTab] = useState('Cab');


  useEffect(() => {
    const capitalizedPageName = pageName
      ? pageName.charAt(0).toUpperCase() + pageName.slice(1)
      : ''
    if (pageName) {
      setCurrentTab(capitalizedPageName)
    }
  }, [pageName])

  return (
    <>
      <div className='rsl-design-header'>
        <Head>
          <meta
            name='viewport'
            content='width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no'
          />
        </Head>
        <Seo pageTitle='Royalsmartlimousine - Lifestyle' />

        <Header3 bgColor="#f6f6f6" borderColor="#DFDFDF" />
      </div>

      <div className='rsl__Wrapper mt-140  sm-px-3 rsl__Wrapper_package'>
        <MainFilterSearchBox
          setCurrentTab={setCurrentTab}
          currentTab={currentTab}
        />

        <div className='my-2'>
          {pageName === 'flights' && <FlightsRSL />}

          {pageName === 'hotels' && <HotelsRSL />}

          {pageName === 'activities' && <ActivitiesRSL />}

          {pageName === 'car' && <CarRSL />}

          {pageName === 'buses' && <BusRSL />}

          {pageName === 'holidays' && <Holidays />}
          {pageName === 'staycations' && <Staycations />}
        </div>

        <VideoBanner router={router} pageName={pageName} />

        <CategorySlider router={router} pageName={pageName} />

        <PopularDestinations
          router={router}
          pageName={pageName}
          title='Trending'
        />

        <BannerSlider router={router} pageName={pageName} />
      </div>

      <Footer3 />
      {/* End Footer Section */}
    </>
  )
}

export default dynamic(() => Promise.resolve(RslHome), { ssr: false })
